/**
 * Pre-compiled localized messages for Combobox component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import comboboxMessages_en from "./intl/en";
import comboboxMessages_de from "./intl/de";
import comboboxMessages_es from "./intl/es";
import comboboxMessages_fr from "./intl/fr-FR";
import comboboxMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const comboboxMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(comboboxMessages_en),
  de: normalizeMessages(comboboxMessages_de),
  es: normalizeMessages(comboboxMessages_es),
  "fr-FR": normalizeMessages(comboboxMessages_fr),
  "pt-BR": normalizeMessages(comboboxMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Combobox component
 */
export type ComboboxMessageKey =
  | "clearSelection"
  | "options"
  | "selectedValues"
  | "toggleOptions";
